// removed by extract-text-webpack-plugin
module.exports = {"Appbar":"_3IfkHs4TXG4zXigMUBM4zv","Appbar-brand":"sYC8Ui8-PeU6xacHHvq-3"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/Appbar.less
 ** module id = 847
 ** module chunks = 0
 **/